export default __webpack_public_path__ + "static/media/white_gear.e331c745.svg";